import type { CanvasTarget, WorkspaceTurnContext } from '../types';

// Making a new agent, as Apps and Skills make one (`canvas=agent&id=new`): a new
// chat with "Making a new agent" in its composer and the draft agent canvas
// waiting beside it. The chat carries `newAgent` in its workspace context, so the
// model drafts the agent from the conversation (server agents/turn.mjs
// NEW_AGENT_GUIDANCE); the saved draft then replaces this canvas in place.
export const NEW_AGENT_CANVAS: CanvasTarget = { kind: 'agent', id: 'new' };

export const isNewAgentCanvas = (canvas: CanvasTarget | null | undefined): boolean =>
  canvas?.kind === 'agent' && canvas.id === NEW_AGENT_CANVAS.id;

/** Whether this chat is the one a new agent is being made in. */
export const makingNewAgent = (context: WorkspaceTurnContext) =>
  context.intent.mode === 'chat' && context.newAgent === true;

/** The chat's context without the new-agent flag (its chip removed, or the agent created). */
export function withoutNewAgent(context: WorkspaceTurnContext): WorkspaceTurnContext {
  const { newAgent: _newAgent, ...rest } = context;
  return rest;
}
